import React from 'react';
import SellerOnboarding from '../../components/SellerOnboarding';
import { styles } from './styles';

const OnboardingContent = ({ user, onComplete }) => {
  return (
    <div style={styles.contentWrapper}>
      <SellerOnboarding 
        user={user} 
        onComplete={onComplete}
      />
    </div>
  );
};

export default OnboardingContent;